import React, { useEffect, useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { treeWithLeaf } from '../../../images/btnIcons';
import LanguageTranslater from '../../HOC/LanguageTranslater';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { LinkIcon, InfoIcon, CheckmarkIcon } from "unified-ui-components-library/dist/systemIcons"
import { Badge, Button } from 'unified-ui-components-library';
import { done, editorChoiceIcn, heartShapeEarth, quickreplyIcn, recyclingIcn } from '../../../images/images';
import { getApiData } from '../../../api/api';
import AxiosRequest from '../../../utils/axios';


const useStyles = makeStyles({
    container: {
        position: 'relative',
        borderRadius: 8,
    },
    accordion: {
        boxShadow: 'none',
        marginBottom: 0
    },
    bottomIcon: {
        display: 'flex',
        justifyContent: 'center',
        borderTop: '1px solid var(--color-border-mb100)'
    },
});

const axios = new AxiosRequest().getClient();

const GoGreenPolicyPack = ({ translate }) => {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(false)
    const [samplePolicyLink, setSamplePolicyLink] = useState("")

    const viewSamplePolicy = () => {
        const refLink = document.createElement('a');
        refLink.href = samplePolicyLink;
        refLink.target = "_blank";
        refLink.click()
    }

    const getSampleUrl = async() => {
        try {
            const { url, body } = getApiData("biDetail")
            body.request.payload.documentType = "goGreen"
            const response = await axios.post(url, body)
            setSamplePolicyLink(response?.data?.response?.payload?.goGreenS3Url)
        } catch (err) {
            console.log({ err })
        } 
    }

    useEffect(() => {
        getSampleUrl();
    }, [])



    return (
        <div className={`${classes.container} go-green-policy-pack-wrapper`}>
            <Accordion
                expanded={isExpanded}
                className={`${classes.accordion} accordianWrap-policy-pack`}
            >
                <AccordionSummary
                    className='go-green-policy-pack-summary'
                >
                    <div className="go-green-main-txt-cntnr">
                        <div className='gg-main-txt-pp-cntnr'>
                            {/* <p className='gg-badge'>
                                <span>
                                    <img src={done} alt='check' />
                                </span>
                                <span>100% Valid ~ Digital Policy Pack!</span>
                            </p> */}
                            <Badge iconLeft={<CheckmarkIcon fillColor='var(--color-text-success)' />} variant='badge' state='success' size='small' style='simple' >
                                <p className='gg-badge-txt'>100% Valid ~ Digital Policy Pack!</p>
                            </Badge>
                            <p className="go-green-main-txt">
                                {
                                    "Your digital policy pack will be sent to your registered email and mobile, and it is fully valid and equivalent to a physical document."
                                }
                            </p>
                        </div>
                        <img
                            src={treeWithLeaf}
                            alt="treeIcn"
                        />
                    </div>
                </AccordionSummary>
                <AccordionDetails
                    className='accordion-detail-gg-policy-pack'
                >
                    <div className='gg-pp-details-cntnr'>
                        <p className='why-gg'>Why the <span className='gg-green-txt'>Go Green</span> option?</p>
                        <div className='gg-benefits'>
                            <div className='gg-img-wrpr'>
                                <img src={quickreplyIcn} alt='benefit_img' />
                                <p className='gg-b-txt'>Instant digital delivery (email + SMS)</p>
                            </div>
                            <div className='gg-img-wrpr'>
                                <img src={editorChoiceIcn} alt='benefit_img' />
                                <p className='gg-b-txt'>Legally valid as original</p>
                            </div>
                            <div className='gg-img-wrpr'>
                                <img src={recyclingIcn} alt='benefit_img' />
                                <p className='gg-b-txt'>Better for the environment</p>
                            </div>
                        </div>
                        <div className='gg-stats'>
                            <img src={heartShapeEarth} alt='earth_heart' />
                            <p className=''>
                                Join <span>75,000+</span> customers who helped save <span>40+ tons</span> of paper.
                            </p>
                        </div>
                        <Button
                            buttonType='outline'
                            iconLeft={<LinkIcon size='small' />}
                            style={{
                                height: "32px"
                            }}
                            size='small'
                            onClick={viewSamplePolicy}
                        >
                            View Sample Policy Pack
                        </Button>
                    </div>
                    <div className='gg-pp-info-cntnr'>
                        <div className='gg-pp-info'>
                            <Button
                                buttonType='neutralLink'
                                iconLeft={
                                    <InfoIcon />
                                }
                            ></Button>
                            <p className='micro-fnt'>In case, you need a detailed physical copy, please place a request anytime with us during the policy life cycle, over an email or a call.</p>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
            <div className={classes.bottomIcon}>
                <IconButton onClick={() => setIsExpanded(prev => !prev)}>
                    <ExpandMoreIcon
                        style={{
                            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s',
                        }}
                    />
                </IconButton>
            </div>
        </div>
    );
}

export default LanguageTranslater(GoGreenPolicyPack);